// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__csRl5","buttons":"RemoveExpirationActionButtons_buttons__1RXJd"};